import { render, staticRenderFns } from "./swiper2.vue?vue&type=template&id=11175d78&scoped=true"
import script from "./swiper2.vue?vue&type=script&lang=js"
export * from "./swiper2.vue?vue&type=script&lang=js"
import style0 from "./swiper2.vue?vue&type=style&index=0&id=11175d78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11175d78",
  null
  
)

export default component.exports